module.exports = __webpack_public_path__ + "static/media/vnv.cd120311.svg";